import i18n from "../i18n/i18n";

export const translate =
  (ns) => (str: string, options?: i18n.TranslationOptions) =>
    i18n.t(str, {
      ...options,
      ns,
    });
